<template>
  <div class="h-100">
    <v-chart ref="chart" :options="options" :init="init" />
  </div>
</template>

<script>
import { comma } from '@/utils/formatter';

export default {
  props: {
    title: String,
    value: {
      type: Object,
      required: true,
    },
  },
  watch: {
    value: {
      deep: true,
      handler(data) {
        this.setData(data);
      },
    },
  },
  data() {
    return {
      locks: 0,
      data: [],
      init: {
        xAxis: {
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          axisLine: {
            show: false,
          },
        },
        grid: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        },
      },
    };
  },
  computed: {
    options() {
      const options = {
        title: [
          {
            text: '{name|Locks}\n{val|' + this.locks + '}',
            top: 'center',
            left: 'center',
            textStyle: {
              rich: {
                name: {
                  fontSize: 14,
                  fontWeight: 'normal',
                  color: '#666666',
                  padding: [10, 0],
                },
                val: {
                  fontSize: 28,
                  fontWeight: 'bold',
                  color: '#6b717d',
                },
              },
            },
          },
        ],
        yAxis: [
          {
            axisLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            type: 'pie',
            radius: ['30%', '40%'],
            center: ['50%', '50%'],
            data: this.data,
            hoverAnimation: false,
            labelLine: {
              normal: {
                length: 20,
                length2: 120,
                lineStyle: {
                  color: '#e6e6e6',
                },
              },
            },
            label: {
              normal: {
                formatter: params => {
                  return '{icon|●}{name|' + params.name + '}{value|' + comma(params.value) + '}';
                },
                padding: [0, -100, 25, -100],
                rich: {
                  icon: {
                    fontSize: 16,
                  },
                  name: {
                    fontSize: 14,
                    padding: [0, 10, 0, 4],
                    color: '#666666',
                  },
                  value: {
                    fontSize: 18,
                    fontWeight: 'bold',
                    color: '#6b717d',
                  },
                },
              },
            },
          },
        ],
      };
      return options;
    },
  },
  methods: {
    setData(data) {
      this.lock = data.locks;
      this.data = [
        {
          name: 'Ø R.T. (ms)',
          value: data.respTime,
        },
        {
          name: 'Queries',
          value: data.queries,
        },
      ];
    },
  },
};
</script>
